var statisticsOption = {
    legend: {
        data: [],
        bottom: 0,
    },
    tooltip: {
        trigger: 'axis',
        position: function (pt) {
            return [pt[0], '10%'];
        },
        backgroundColor: "rgba(255,255,255,0.8)",
        borderWidth: "1",
        borderColor: "#aaa",
        textStyle: {
            color: "#666"
        },
    },
    title: {
        left: 'center',
        text: '',
        top: 10
    },
    xAxis: {
        type: 'category',
        axisTick: { show: false },
        axisLabel: { interval: 0, rotate: 30 },
        data: []
        //data: [1,2,3,4,5]
    },
    yAxis: {
        type: 'value',
        name: '',
        minInterval: 0
    },
    series: [{
        type: 'bar',
        barWidth: '5%',
        label: {
            show: true,
            position: 'top',
            textStyle: {
                color: '#666'
            }
        },
        color: '',
        markPoint: {
            symbol: 'pin',
            symbolSize: 1,
            itemStyle: { color: '#fff' },
            label: { rotate: 90, color: '#fff' },
            data: []
        },
        data: []
        //data: [1000, 700, 800, 600, 780]
    }]
};

export { statisticsOption }